import React, { Fragment, FunctionComponent } from 'react';
import { PageWrapper } from 'components/presentional';
import { Redirect, useParams } from 'react-router-dom';
import { usePosts } from 'hooks';
import { WPAcfCaseStudy } from 'types/acf';
import { WPSimpleArticle } from 'types/articles';
import { useRouteTranslations } from 'utils';
import { Company, Statistics, RecruitmentSteps, Testimonials, CompanyLogos } from 'components/containers';

interface OwnProps {}

type ArticlePageProps = Omit<JSX.IntrinsicElements['article'], 'children'> & OwnProps;

const ArticlePage: FunctionComponent<ArticlePageProps> = props => {
  let { articleId } = useParams<any>();
  const { translateSlug } = useRouteTranslations();
  const { data: post, loading } = usePosts<WPSimpleArticle<WPAcfCaseStudy>>({ slug: articleId });
  const [postData] = post || [];

  if (!articleId) {
    return <Redirect to={translateSlug('not_found')} />;
  }

  const renderContent = (post: WPSimpleArticle<WPAcfCaseStudy>) => {
    const {
      acf: { company, statistics, testimonials, recruitmentSteps, companyLogos },
    } = post;

    return (
      <Fragment>
        {company && <Company data={company} />}
        {statistics && <Statistics data={statistics} />}
        {recruitmentSteps && <RecruitmentSteps data={recruitmentSteps} />}
        {testimonials && <Testimonials theme="light" data={testimonials} />}
        {companyLogos && <CompanyLogos data={companyLogos} />}
      </Fragment>
    );
  };

  return (
    <PageWrapper title={postData?.yoast_title} meta={postData?.yoast_meta} loading={loading} name={'case-study'}>
      {post && postData && renderContent(postData)}
    </PageWrapper>
  );
};

export default ArticlePage;
